import $ from 'jquery';

/**
 * Main application initialization function
 * Updated to use modern JavaScript patterns and avoid deprecated jQuery methods
 */
const AppRun = () => {
  // Modern Google Analytics implementation
  // You might want to consider using Google Tag Manager or the newer gtag.js
  const initGoogleAnalytics = () => {
    (function(i,s,o,g,r,a,m){i['GoogleAnalyticsObject']=r;i[r]=i[r]||function(){
    (i[r].q=i[r].q||[]).push(arguments)},i[r].l=1*new Date();a=s.createElement(o),
    m=s.getElementsByTagName(o)[0];a.async=1;a.src=g;m.parentNode.insertBefore(a,m)
    })(window,document,'script','//www.google-analytics.com/analytics.js','ga');
    ga('create', 'UA-89596-1', 'sukhchander.com');
    ga('send', 'pageview');
  };

  // Handle preloader fadeout
  const handlePreloader = () => {
    // Modern event handler
    $(window).on('load', () => {
      $('#status').fadeOut();
      $('#preloader').delay(300).fadeOut('slow');
    });
  };

  // Initialize all UI interactions
  const initUI = () => {
    // Use the shorthand document ready pattern
    $(() => {
      // Bootstrap scrollspy - check if available before initializing
      if ($.fn.scrollspy) {
        $('body').scrollspy({
          target: '.navbar-custom',
          offset: 50
        });
      }

      // Smooth scrolling with modern selector and event handling
      $('a[href*="#"]:not([href="#"])').on('click', (e) => {
        e.preventDefault();
        const anchor = $(e.currentTarget);
        const targetElement = $(anchor.attr('href'));
        
        if (targetElement.length) {
          $('html, body').animate({
            scrollTop: targetElement.offset().top
          }, 1000);
        }
      });

      // Background image slideshow with Backstretch
      if ($.fn.backstretch) {
        const images = [
          '//storage.googleapis.com/assets.sukhchander.com/images/r2.jpg',
          '//storage.googleapis.com/assets.sukhchander.com/images/r3.jpg',
          '//storage.googleapis.com/assets.sukhchander.com/images/r5.jpg',
          '//storage.googleapis.com/assets.sukhchander.com/images/r7.jpg'
        ];

        $('#intro').backstretch(images, { duration: 4000, fade: 1000 });
      }

      // Navbar color change with modern event handler
      const navbar = $('.navbar');
      const navHeight = navbar.height();

      $(window).on('scroll', () => {
        if ($(window).scrollTop() >= navHeight) {
          navbar.addClass('navbar-color');
        } else {
          navbar.removeClass('navbar-color');
        }
      });

      // Responsive navbar - check once at load
      handleResponsiveNavbar();
      
      // Check on resize with debounce for better performance
      let resizeTimeout;
      $(window).on('resize', () => {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(handleResponsiveNavbar, 250);
      });

      // Initialize contact form
      initContactForm();
    });
  };

  // Handle responsive navbar in a separate function
  const handleResponsiveNavbar = () => {
    const navbar = $('.navbar');
    if ($(window).width() <= 767) {
      navbar.addClass('custom-collapse');
    } else {
      navbar.removeClass('custom-collapse');
    }
  };

  // Email validation using modern regex pattern
  const isValidEmail = (email) => {
    // Simplified pattern for better readability
    const pattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
    return pattern.test(email);
  };

  // Initialize contact form with modern event handling
  const initContactForm = () => {
    const $form = $('#contact-form');
    const $responseMessage = $('.ajax-response');
    
    $form.on('submit', (e) => {
      e.preventDefault();

      const name = $('#name').val();
      const email = $('#email').val();
      const message = $('#message').val();
      
      // Form validation
      if (!name || !email || !message || !isValidEmail(email)) {
        $responseMessage
          .html('<i class="fa fa-warning"></i> Please fill all fields correctly')
          .fadeIn(500);
        return false;
      }
      
      // Show loading state
      const $submitButton = $form.find('button[type="submit"]');
      $submitButton
        .html('<i class="fa fa-cog fa-spin"></i> Sending')
        .prop('disabled', true);
      
      // Send data using fetch API instead of $.ajax
      fetch('//sinatra-connect.onrender.com/connect', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          name,
          email,
          message
        })
      })
      .then(response => response.json())
      .then(result => {
        if (result.success) {
          $responseMessage
            .html("I'll get back to you soon like really soon")
            .fadeIn(500);
          $form.fadeOut(500);
        } else {
          $submitButton
            .html('<i class="fa fa-retweet"></i> Give it another shot')
            .prop('disabled', false);
          $responseMessage
            .html('Try again')
            .fadeIn(500);
        }
        $('#ajax-status').removeClass('as-active');
      })
      .catch(error => {
        console.error('Error submitting form:', error);
        $submitButton
          .html('<i class="fa fa-retweet"></i> Give it another shot')
          .prop('disabled', false);
        $responseMessage
          .html('Something went wrong. Please try again.')
          .fadeIn(500);
      });
      
      return false;
    });
  };

  // Initialize everything
  const init = () => {
    initGoogleAnalytics();
    handlePreloader();
    initUI();
  };

  // Run initialization
  init();
};

export default AppRun;